import React from "react";
import { Card, IconButton, Tooltip, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Div from "@jumbo/shared/Div";
import { useTranslation } from "react-i18next";

const ZONES_I18N = "pages.dsokDetails.accessSystem.zones";

const ZoneListItem = ({
  item,
  onEdit,
  onDelete,
  resolveStatusLabel,
  devicesCount,
}) => {
  const { t } = useTranslation();
  const desc =
    item.description != null && String(item.description).trim() !== ""
      ? String(item.description).trim()
      : "—";

  return (
    <Card
      sx={{ mb: 1, cursor: "pointer" }}
      onClick={() => onEdit(item.id)}
    >
      <Div
        sx={{
          px: 3,
          py: 1.5,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "center" },
          justifyContent: "space-between",
          flexWrap: "wrap",
          rowGap: { xs: 1.5, md: 0 },
        }}
      >
        <Div sx={{ flex: { xs: "1 1 100%", md: 1.1 }, minWidth: 0, px: 1 }}>
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t(`${ZONES_I18N}.list.columns.name`, { defaultValue: "Name" })}
          </Typography>
          <Typography variant="body1">{item.name || "—"}</Typography>
        </Div>

        <Div sx={{ flex: { xs: "1 1 100%", md: 1.2 }, minWidth: 0, px: 1 }}>
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t(`${ZONES_I18N}.list.columns.description`, {
              defaultValue: "Description",
            })}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {desc}
          </Typography>
        </Div>

        <Div sx={{ flex: { xs: "1 1 100%", md: 0.55 }, minWidth: 0, px: 1 }}>
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t(`${ZONES_I18N}.list.columns.status`, {
              defaultValue: "Status",
            })}
          </Typography>
          <Typography variant="body1">
            {resolveStatusLabel(item.isActive)}
          </Typography>
        </Div>

        <Div sx={{ flex: { xs: "1 1 100%", md: 0.45 }, minWidth: 0, px: 1 }}>
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t(`${ZONES_I18N}.list.columns.devicesCount`, {
              defaultValue: "Devices",
            })}
          </Typography>
          <Typography variant="body1">{devicesCount}</Typography>
        </Div>

        <Div
          sx={{
            flex: { xs: "1 1 auto", md: 0 },
            px: 1,
            alignSelf: { xs: "flex-end", md: "center" },
          }}
        >
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t("pages.presentation.actions")}
          </Typography>
          <Div
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 0.5,
              minWidth: 40,
            }}
          >
            <Tooltip title={t("buttons.edit")} placement="top-start">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(item.id);
                }}
                aria-label={t("buttons.edit")}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={t(`${ZONES_I18N}.list.delete`, {
                defaultValue: "Delete zone",
              })}
              placement="top-start"
            >
              <IconButton
                size="small"
                color="error"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(item);
                }}
                aria-label={t("buttons.delete")}
              >
                <DeleteOutlineIcon />
              </IconButton>
            </Tooltip>
          </Div>
        </Div>
      </Div>
    </Card>
  );
};

export default ZoneListItem;
